import MicroModal from 'micromodal';
import { template } from './template';
import { htmlToElement } from '../../common/dom';
import { MODAL_ID } from '../MobileCalendarModal/constants';
import fillContactUsWhatsAppWithDates from '../MobileCalendarModal/fillContactUsWhatsAppWithDates';

export const open = ({ onShow, onClose }) => {
  const body = document.querySelector('body');
  const modal = document.getElementById(MODAL_ID);

  const handleOnClose = modal => {
    onClose && onClose(modal);
  };

  const handleOnShow = modal => {
    onShow && onShow(modal);
  };

  if (modal) {
    MicroModal.close(MODAL_ID);
    modal.remove();
  }

  const html = template();
  body.appendChild(htmlToElement(html));

  MicroModal.show(MODAL_ID, { onShow: handleOnShow, onClose: handleOnClose });
  fillContactUsWhatsAppWithDates(window);
};

export const close = () => {
  if (window.isWebview) {
    window.ReactNativeWebView.postMessage('CloseButtonClicked');
  }

  const modal = document.getElementById(MODAL_ID);
  MicroModal.close(MODAL_ID);
  modal.remove();
};
